(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
  , itemSchema = require('./item-schema')
const required = require('@clocklimited/validity-required')

module.exports = function () {

  return schemata(
    { showId:
      { type: String
      , all: [ required ]
      }
    , items:
      { type: schemata.Array(itemSchema)
      , all: [ required ]
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/itinerary/entry-schema.js","/components/service/itinerary")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvc2VydmljZS9pdGluZXJhcnkvZW50cnktc2NoZW1hLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsidmFyIHNjaGVtYXRhID0gcmVxdWlyZSgnc2NoZW1hdGEnKVxuICAsIGl0ZW1TY2hlbWEgPSByZXF1aXJlKCcuL2l0ZW0tc2NoZW1hJylcbmNvbnN0IHJlcXVpcmVkID0gcmVxdWlyZSgnQGNsb2NrbGltaXRlZC92YWxpZGl0eS1yZXF1aXJlZCcpXG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gKCkge1xuXG4gIHJldHVybiBzY2hlbWF0YShcbiAgICB7IHNob3dJZDpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICAsIGFsbDogWyByZXF1aXJlZCBdXG4gICAgICB9XG4gICAgLCBpdGVtczpcbiAgICAgIHsgdHlwZTogc2NoZW1hdGEuQXJyYXkoaXRlbVNjaGVtYSlcbiAgICAgICwgYWxsOiBbIHJlcXVpcmVkIF1cbiAgICAgIH1cbiAgICB9XG4gIClcbn1cbiJdfQ==